import { render, staticRenderFns } from "./PosReportModal.vue?vue&type=template&id=4ba88380"
import script from "./PosReportModal.vue?vue&type=script&lang=js"
export * from "./PosReportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports